// Auto-generated translation for ga.
// Source: kennisbank.js, translated via Claude Sonnet on 2026-05-26T11:27:49.776143+00:00.

export const KENNISBANK = {
  "paarden-gezondheid": {
    slug: "paarden-gezondheid",
    category: "Sláinte",
    title: "Sláinte Capaill — treoir chuimsitheach",
    lead: "Tosaíonn sláinte capaill le breathnóireacht mhaith, coinneáil taifead rialta agus saineolaithe a thabhairt isteach in am. Sa treoir seo, míníonn muid na bunphrionsabail: comharthaí laethúla, seiceálacha, cosc agus cathain a ghlaofá ar an tréidlia.",
    datePublished: "2026-05-01",
    sections: [
      {
        h: "Cad is sláinte capaill ann?",
        p: "Is mó ná 'gan bheith tinn' atá i gceist le sláinte capaill. Baineann sé le córas gluaisne atá ag feidhmiú go maith, díleá sláintiúil, cothromaíocht mheabhrach agus cúram coiscneach rialta. Tacaíonn EquiSight le gach ceann de na colúin sin in aon taifead amháin in aghaidh an chapaill.",
      },
      {
        h: "Comharthaí laethúla",
        list: [
          "Goile agus úsáid uisce",
          "Iompar sa stábla agus sa pháirc",
          "Cac (comhsheasmhacht, minicíocht)",
          "Seasamh agus gluaiseacht",
          "Coat agus riocht craicinn",
          "Buille croí agus análú ar scíth",
        ],
      },
      {
        h: "Bainistíocht choiscneach",
        p: "Is é an cosc an chuid is mó de shláinte mhaith capaill. Coinnigh vacsaínithe, díchoinneáil, seiceálacha fiacla agus cúram crúb ar bun go leanúnach. Seolann EquiSight meabhrúcháin go huathoibríoch.",
      },
      {
        h: "Cathain a ghlaofá ar an tréidlia?",
        list: [
          "Gan ithe ná ól (>4 uair an chloig)",
          "Comharthaí coilice",
          "Bacaíocht tobann",
          "Fiabhras ard (>38.5°C)",
          "Créachtaí nach stopann ag cur fola",
          "Deacrachtaí breith",
        ],
      },
    ],
    faq: [
      {
        q: "Cé chomh minic is ceart capall a thabhairt chuig an bhfiaclóir?",
        a: "Uair amháin sa bhliain do chapaill fhásta. Capaill óga (3–5 bliana d'aois) agus seanóirí níos minice.",
      },
      {
        q: "Cé na vacsaínithe atá éigeantach?",
        a: "I gcomórtais KNHS, tá vacsaíniú fliú de réir sceideal éigeantach. Moltar go láidir vacsaíniú teitineas.",
      },
    ],
    related: [
      "entingen",
      "voeradvies",
      "hoefverzorging",
    ],
  },
  "voeradvies": {
    slug: "voeradvies",
    category: "Cothú",
    title: "Comhairle beathaithe capall — bunrialacha agus gaistí coitianta",
    lead: "Is é cothú maith bunús shláinte an chapaill. Sa treoir seo: féar tirim, beathú cumhachta, forlíontáin, meáchan agus innéacs frúctáin mínithe.",
    datePublished: "2026-05-02",
    sections: [
      {
        h: "Cé mhéad féar tirim a theastaíonn ó chapall?",
        p: "Teastaíonn 1.5–2% dá mheáchan coirp i gceathrúlach (féar tirim/sílidh) in aghaidh an lae ó chapall meánach. Do chapall 500kg, is ionann sin agus 7.5–10kg féar tirim.",
      },
      {
        h: "Beathú cumhachta — cathain atá sé riachtanach?",
        p: "Ní gá beathú cumhachta ach amháin i gcás oibre déine, toirchis, lachtú nó riachtanas fuinnimh ar leith. Faigheann go leor capall beathú cumhachta gan ghá, rud a fhágann róthrom agus fadhbanna meitibileacha.",
      },
      {
        h: "Forlíontáin",
        list: [
          "Salann/mianraí (ar fáil saor in aisce)",
          "Maignéisiam le haghaidh struis / matán",
          "Bitin le haghaidh fadhbanna crúb",
          "Glúcósaimín le haghaidh na gcomhalt",
        ],
      },
      {
        h: "Innéacs frúctáin — bí cúramach le féar",
        p: "Go háirithe ar maidin san earrach agus nuair a bhíonn oícheanta fuar ann in éineacht le laethanta gréine, bíonn ábhar frúctáin an fhéir an-ard. Tá sé seo contúirteach d'adharcaíl. Tugann EquiSight rabhadh go huathoibríoch.",
      },
    ],
    faq: [
      {
        q: "An gcaithfidh mé beathú cumhachta a thabhairt i gcónaí?",
        a: "Ní chaithfidh. Tá go leor capall sásta le ceathrúlach maith agus forlíontán mianraí. Ná húsáid beathú cumhachta ach amháin nuair a theastaíonn tuilleadh fuinnimh.",
      },
      {
        q: "Conas a bheidh a fhios agam an bhfuil mo chapall róthrom?",
        a: "Scór riochta coirp (BCS) agus crios tomhais. Cabhraíonn EquiSight leat é a rianú agus tugann sé rabhaidh treochta duit.",
      },
    ],
    related: [
      "fructaan-index",
      "paarden-gezondheid",
    ],
  },
  "hoefverzorging": {
    slug: "hoefverzorging",
    category: "Cúram Crúb",
    title: "Cúram crúb capaill — gach rud ba chóir duit a fhios a bheith agat",
    lead: "Gan crúb, gan capall. Éilíonn cúram crúb comhsheasmhacht: bearradh nó crúití, seiceáil rialta, stábla tirim agus aiste bia mhaith.",
    datePublished: "2026-05-03",
    sections: [
      {
        h: "Cé chomh minic ba chóir don gabha crúb teacht?",
        p: "Gach 6–8 seachtaine ar an meán. Beagán níos giorra le crúití, is féidir le crúb lom a bheith beagán níos faide. Coinnigh é rialta — seolann EquiSight meabhráin go huathoibríoch.",
      },
      {
        h: "Crúití nó crúb lom?",
        p: "Is féidir an dá rogha a bheith maith, ag brath ar an gcapall, an disciplín agus coinníollacha an stábla/an léana. Pléigh le do ghabha crúb.",
      },
      {
        h: "Comharthaí fadhbanna crúibe",
        list: [
          "Siúl neamhrialta",
          "Artairí ag preabadh",
          "Teas sa chrúb",
          "Scoilteanna nó briseadh",
          "Bolaidh lofa ón gceirtlín",
        ],
      },
    ],
    faq: [
      {
        q: "Cad a dhéanann gabha crúb go díreach?",
        a: "Bearradh (an crúb a cheartú agus a shlíocadh), crúití a choigeartú nó nua a chur air más gá, agus sláinte ghinearálta an chrúib a mheas.",
      },
    ],
    related: [
      "paarden-gezondheid",
    ],
  },
  "entingen": {
    slug: "entingen",
    category: "Sláinte",
    title: "Vacsaínithe capall — sceideal, cineálacha agus rialacha",
    lead: "Cé na vacsaínithe a bhfuil gá ag capall leo? Fliú, teiteanais, rhinopneumóine agus víreas Níleas Thiar. Sceidil agus rialacha KNHS leagtha amach.",
    datePublished: "2026-05-04",
    sections: [
      {
        h: "Fliú",
        p: "Sraith tosaigh de 3 vacsaíniú (seachtain 0, 4, 6 mhí), ansin go bliantúil. Éigeantach do chomórtais KNHS agus vacsaínithe le 6 mhí ar a mhéad.",
      },
      {
        h: "Teiteanais",
        p: "Sraith tosaigh de 2 (seachtain 0 agus 4 seachtaine), ansin gach 2–3 bliana. Molta go láidir do gach capall.",
      },
      {
        h: "Rhinopneumóine (EHV-1/4)",
        p: "Go háirithe i stáblaí le go leor capaill agus i gcás láracha troma. Gach 6 mhí.",
      },
      {
        h: "Víreas Níleas Thiar",
        p: "Molta i gceantair ardriosca. Go bliantúil, roimh shéasúr na gcuileog.",
      },
    ],
    faq: [
      {
        q: "Cad a tharlaíonn má vacsaíníodh mo chapall ródhéanach?",
        a: "I gcás fliú, is minic gur gá tosú arís le sraith bhunúsach. Tugann EquiSight rabhadh in am.",
      },
    ],
    related: [
      "paarden-gezondheid",
    ],
  },
  "fructaan-index": {
    slug: "fructaan-index",
    category: "Cothú",
    title: "Innéacs frúctáin capaill — cad é agus conas é a úsáid",
    lead: "Cad é an t-innéacs frúctáin? Cathain a bhíonn féar contúirteach do do chapall? Conas laminíteas a chosc le sonraí agus pleanáil.",
    datePublished: "2026-05-05",
    sections: [
      {
        h: "Cad é frúctán?",
        p: "Is siúcra é frúctán a stórálann féar. Ag tiúchaint arda, is féidir leis seo coipeadh a chruthú sa stéig mhór agus dá bharr sin laminíteas (bevangenheid crúb) a chur faoi deara.",
      },
      {
        h: "Cathain a bhíonn frúctán ard?",
        list: [
          "Oícheanta fuar + laethanta grianmhara (earrach, fómhar)",
          "Go luath ar maidin",
          "Tar éis sioc oíche",
          "Féar faoi strus (tar éis barra, triomach, gearrtha)",
        ],
      },
      {
        h: "Conas é a rianú?",
        p: "Ríomhann EquiSight an t-innéacs frúctáin do gach féarach agus tugann rabhadh i gcás riosca ard. Comhcheangail le hamanna innilte ar son bainistíocht is fearr.",
      },
    ],
    faq: [
      {
        q: "Cé na capaill a bhfuil riosca breise acu?",
        a: "Póiníthe (go háirithe Shetland agus Welsh), capaill ró-throm, capaill le EMS agus Cushing, agus capaill ar tharla laminíteas dóibh cheana.",
      },
    ],
    related: [
      "voeradvies",
      "paarden-gezondheid",
    ],
  },
  "koliek": {
    slug: "koliek",
    category: "Galair",
    title: "Coilic capaill — comharthaí, cúiseanna & cad ba chóir a dhéanamh",
    lead: "Is pian bhoilg é coilic. I gcás capall, tá sé tromchúiseach i gcónaí — glaoigh ar an tréidlia láithreach má tá amhras ort. Léigh anseo faoi chomharthaí, cúiseanna agus garchabháir.",
    datePublished: "2026-05-06",
    sections: [
      {
        h: "Comharthaí",
        list: [
          "Gan ithe ná ól",
          "Corrthónach, ag scríobadh na talún",
          "Ag luí síos agus ag éirí arís",
          "Ag féachaint ar an mbolg nó ag ciceáil chuige",
          "Ag cur allais gan stró",
          "Ráta croí ardaithe (>48/nóiméad)",
        ],
      },
      {
        h: "Cúiseanna",
        list: [
          "Athruithe ar aiste bia",
          "Easpa uisce (go háirithe sa gheimhreadh)",
          "Barraíocht beatha tiubhaithe",
          "Ionghabháil gainimh",
          "Strus",
          "Ionfhabhtú péisteanna",
        ],
      },
      {
        h: "Cad ba chóir a dhéanamit?",
        p: "Glaoigh ar an tréidlia láithreach. Ná lig don chapall rolladh má tá coilic throm air. Siúil go ciúin más féidir. Coinnigh bia agus uisce ar shiúl go dtí go dtiocfaidh an tréidlia.",
      },
    ],
    faq: [
      {
        q: "An féidir liom coilic a chosc?",
        a: "Go páirteach: féar garbh cobhsaí, uisce leordhóthanach, gluaiseacht leordhóthanach, díphéisteáil rialta agus gan athruithe tobanna ar an aiste bia.",
      },
    ],
    related: [
      "paarden-gezondheid",
      "voeradvies",
    ],
  },
  "droes": {
    slug: "droes",
    category: "Galair",
    title: "Droes capall — comharthaí, tarchur & leithlisiú",
    lead: "Tá droes (strangles) an-tógálach. Tá aithint thapa agus leithlisiú ríthábhachtach chun ráig sa stábla a chosc.",
    datePublished: "2026-05-07",
    sections: [
      {
        h: "Comharthaí",
        list: [
          "Fiabhras (>39°C)",
          "Gan goile",
          "At faoi na gialla",
          "Sruth srónach purúlach",
          "Easpaí a phléascann oscailte",
        ],
      },
      {
        h: "Leithlisiú",
        p: "Cuir an capall amhrasach faoi choraintín láithreach. Cúram ar leith, ábhair ar leith, sláinteachas docht. Capaill eile a scagadh.",
      },
    ],
    faq: [
      {
        q: "Cé chomh fada a mhaireann droes?",
        a: "De ghnáth 2–6 seachtaine. Fanann roinnt capaill ina n-iompróirí trí na málaí aeir — lig iad a scrúdú.",
      },
    ],
    related: [
      "paarden-gezondheid",
    ],
  },
  "zomereczeem": {
    slug: "zomereczeem",
    category: "Riochtaí",
    title: "Eachma samhraidh capaill — cosc & cóireáil",
    lead: "Is freagairt ailléirgeach é eachma samhraidh ar sheile na gcuileoga beaga (Culicoides). Léigh faoi chosc agus cóireáil.",
    datePublished: "2026-05-08",
    sections: [
      {
        h: "Comharthaí",
        list: [
          "Tochas, go háirithe ar mhuineál agus bun na heireabaill",
          "Spásanna maola agus crústaí",
          "Míshuaimhneas um thráthnóna agus ar maidin",
        ],
      },
      {
        h: "Cosc",
        list: [
          "Blaincéad eachma le flap bolg agus caipín",
          "Coimead sa stábla i rith buaicuaireanta (luí agus éirí gréine)",
          "Ionlacán frith-fheithidí",
          "Quashtán sa stábla",
          "I bhfad ó limistéir uisce",
        ],
      },
    ],
    faq: [
      {
        q: "An gcabhraíonn cothú le heachma samhraidh?",
        a: "Tacaíonn roinnt forlíontán (óméaga-3, vitimín E) leis an gcraiceann agus leis an gcóras imdhíonachta, ach ní leigheasann siad é.",
      },
    ],
    related: [
      "paarden-gezondheid",
    ],
  },
};

export default KENNISBANK;
